import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';

@Component({
    selector: 'app-activities',
    templateUrl: './activities.component.html',
    styleUrls: ['./activities.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivitiesComponent implements OnInit {

    constructor(
        public gs: GeneralService) {

    }

    ngOnInit() {
    }

}
